<template>
  <div class='contents'>
    <DescriptionBlock/>

    <CadBlock/>

    <PaymentDescriptionBlock/>

    <OwnerDescriptionBlock/>

    <p>サービスの詳細については以下をご覧ください。</p>

    <router-link :to="{ name: 'Usages'}">
      <img class='base_image' src='@/assets/image/pages/top/button_g.png'>
    </router-link>

    <UsageBlock />
  </div>
</template>

<script>
  import DescriptionBlock from "@/components/objects/block/top/DescriptionBlock";
  import CadBlock from "@/components/objects/block/top/CadBlock";
  import PaymentDescriptionBlock from "@/components/objects/block/top/PaymentDescriptionBlock";
  import OwnerDescriptionBlock from "@/components/objects/block/top/OwnerDescriptionBlock";
  import UsageBlock from "@/components/objects/block/top/UsageBlock";

  export default {
    name: 'TOP',
    components: {UsageBlock, OwnerDescriptionBlock, PaymentDescriptionBlock, CadBlock, DescriptionBlock},
  }
</script>

<style lang="scss" scoped>
  .contents {
    align-items: center;

    .description_block {
      margin: 5rem 0;
      width: 100%;
    }

    .cad_block {
      margin: 5rem 0;
      width: 100%;
    }

    .payment-description_block {
      margin: 5rem 0;
      width: 100%;
    }
    .owner-description_block {
      margin: 5rem 0;
      width: 100%;
    }
    .usage_block {
      margin: 5rem 0;
      width: 100%;
    }

    > p {
      text-align: center;
    }

    > a > .base_image {
      margin: 2rem 0 5rem 0;
      width: 20rem;
    }
  }
</style>
